const excludedRoutes = ['offers-slug-map']

export default function ({ $gtm, route }) {
  if (route.name && !excludedRoutes.includes(route.name.split('__')[0])) {
    $gtm.init()
  }
}
